import Vue from 'vue';
import moduleManager from 'utils/moduleManager';

export default () => {
  Vue.use((v) => {
    v.modules = moduleManager;
    v.prototype.$modules = moduleManager;
  });
};
